export const ACREOS_TEMPLATE = "Acreos Template"